import {CollectionViewer, DataSource} from "@angular/cdk/collections";
import { Observable, BehaviorSubject} from "rxjs";
import { PosmProductionDemandDto, PosmProductionDemandServiceProxy} from '@shared/service-proxies/service-proxies';



export class PosmDemandDataSource implements DataSource<PosmProductionDemandDto> {

    private dataSubject = new BehaviorSubject<PosmProductionDemandDto[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private hasItemsSubject = new BehaviorSubject<boolean>(false);
    private totalCount = new BehaviorSubject<number>(0);
    

    public loading$ = this.loadingSubject.asObservable();
    public hasItems$ = this.hasItemsSubject.asObservable();
    public totalCount$ = this.totalCount.asObservable();

    constructor (
        private _productDemandProxy : PosmProductionDemandServiceProxy
    ){
        
    }   

    connect(collectionViewer: CollectionViewer): Observable<PosmProductionDemandDto[]> {
        return this.dataSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.dataSubject.complete();
        this.loadingSubject.complete();
        this.hasItemsSubject.complete();
    }

    

	loadData(filterKeyword: string, isDeleted: boolean, sorting: string = null,
		maxResultCountPerPage: number, pageIndex: number) {
		//Loading basliyor...
		this.loadingSubject.next(true);



		const skipCount = pageIndex * (maxResultCountPerPage ? maxResultCountPerPage : 0);

		this._productDemandProxy.getAll(filterKeyword, sorting, isDeleted, skipCount, maxResultCountPerPage)
			.subscribe(
				res => {
					this.dataSubject.next(res.items)
					this.totalCount.next(res.totalCount);
					this.hasItemsSubject.next(res.items.length > 0);

                    
				},

				(err) => { }, //Error
				() => {      //OnComplete
					this.loadingSubject.next(false);

				}


			)
	}
   

}
